import NonSecuredRoute from './NonSecuredRoute';

export default NonSecuredRoute;
